(function (Drupal) {
  Drupal.behaviors.inewspro = {};

  let prevScrollPos = window.pageYOffset;
  const header = document.querySelector("header");

  window.addEventListener('DOMContentLoaded', function() {
    let currentScrollPos = window.pageYOffset;
    const hasClass = document.body.classList.contains("gin--horizontal-toolbar");
    if (hasClass) {
      header.style.top = "112px";
      header.classList.add('header-admin');
    } else {
      header.style.top = "0";
      header.classList.add('header-top');
    }
  });

  window.addEventListener('scroll', function() {
    let currentScrollPos = window.pageYOffset;
    const hasClass = document.body.classList.contains("gin--horizontal-toolbar");
    if (prevScrollPos > currentScrollPos) {
      // Показываем заголовок при прокрутке вверх
      if (hasClass && currentScrollPos > 135) {
        header.style.top = "53px";
      } else {
        header.style.top = "0";
        header.classList.remove('header-top');
      }
    } else {
      // Скрываем заголовок при прокрутке вниз
      if (hasClass && currentScrollPos > 135) {
        header.style.top = "-23px";
        header.classList.remove('header-admin');
      } else if (currentScrollPos > 75) {
        header.style.top = "-75px";
        header.classList.remove('header-top');
      }
    }
    if (currentScrollPos < 113 && hasClass) {
      // Показываем заголовок, когда страница достигает верхней части
      header.style.top = "112px";
      header.classList.add('header-admin');
    } else if (currentScrollPos === 0) {
      // Показываем заголовок, когда страница достигает верхней части
      header.style.top = "0";
      header.classList.add('header-top');
    }
    prevScrollPos = currentScrollPos;
  });

})(Drupal);
